import { FunctionComponent } from 'react';
import { FiInfo } from 'react-icons/fi';
import { Tooltip } from 'react-tooltip';

interface InfoTooltipProps {
  id: string;
  text: string;
}

const InfoTooltip: FunctionComponent<InfoTooltipProps> = ({ id, text }) => {
  return (
    <>
      <a data-tooltip-id={`${id}Tooltip`}>
        <FiInfo className="h-4 w-4" />
      </a>
      <Tooltip id={`${id}Tooltip`} className="max-w-[400px] z-50 text-center break-words whitespace-normal">
        {text}
      </Tooltip>
    </>
  );
};

export default InfoTooltip;
